import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {WGGameConfig} from "../../WGGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class WGStackAnimationView extends BaseView {
    private _layer: ScalableLayer;
    private _wildStackidleAnimation: PIXI.spine.Spine[] = [];
    public _aliveMidStackWinAnimation: PIXI.spine.Spine[] = [];
    private _graphicBg: PIXI.Graphics;
    private _midStackIdle: TimelineSprite[] = []; // will have bottom and top part.
    private _graphics: PIXI.Graphics;

    constructor() {
        super();
        this._layer = StageManager.getLayer(WGGameConfig.instance.LAYERS.SYMBOLS.name);
        this._layer.addChild(this);
    }

    protected initAnimations(): void {
        this.createGraphic();
        this.createWildStackIdleAnimation();
        this.createMidStackAnimation();
    }

    public playAliveMidStackWinAnimation(reelIds: number[], symbolName: string): void {
        if (this._aliveMidStackWinAnimation.length) {
            this._aliveMidStackWinAnimation.forEach((value: PIXI.spine.Spine) => {
                this.removeChild(value);
            });
            this._aliveMidStackWinAnimation = [];
        }
        for (let i = 0; i < reelIds.length; i++) {
            let anim: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(`${symbolName.toLowerCase()}_alive_win`));
            anim.position.set(120 * reelIds[i] + 60, 199 * 1.95);
            this._aliveMidStackWinAnimation.push(anim);
            new SpineTween(anim, 0, `${symbolName.toLowerCase()}_alive_win`);
            StageManager.getLayer(WGGameConfig.instance.LAYERS.STICKY.name).addChild(anim);
        }
    }

    public hideALlWinMidStack(): void {
        if (this._aliveMidStackWinAnimation.length) {
            this._aliveMidStackWinAnimation.forEach((value: PIXI.spine.Spine) => {
                value.visible = false;
                this.removeChild(value);
            });
        }
    }

    /**
     * mask create for reel area,
     */
    private createMaskForstackSymbol(): PIXI.Graphics {
        this._graphics = new PIXI.Graphics();
        this._graphics.beginFill(0xFF3300);
        this._graphics.drawRect(0, 90, 780, 594);
        this._graphics.endFill();
        StageManager.getLayer(WGGameConfig.instance.LAYERS.STICKY.name).addChild(this._graphics);
        return this._graphics;
    }

    private createMidStackAnimation(reelId: number = 0, symbolId: number = 2): void {
        let top: TimelineSprite = new TimelineSprite(GameResources.getTextures("mid_stack_idle_half"));
        let bottom: TimelineSprite = new TimelineSprite(GameResources.getTextures("mid_stack_idle_half"));
        let top1: TimelineSprite = new TimelineSprite(GameResources.getTextures("mid_stack_idle_half"));
        let bottom1: TimelineSprite = new TimelineSprite(GameResources.getTextures("mid_stack_idle_half"));

        top.scale.y *= -1;
        top.scale.x *= -1;
        top1.scale.y *= -1;
        top1.scale.x *= -1;

        top.anchor.set(0.5, 1);
        bottom.anchor.set(0.5, 0);
        top1.anchor.set(0.5, 1);
        bottom1.anchor.set(0.5, 0);

        this._midStackIdle.push(top, bottom, top1, bottom1);

        this._midStackIdle.forEach(anim => {
            anim.blendMode = PIXI.BLEND_MODES.ADD;
            anim.visible = false;
            anim.mask = this.createMaskForstackSymbol();
            anim.width -= 10;
            StageManager.getLayer(WGGameConfig.instance.LAYERS.STICKY.name).addChild(anim);
        });
    }

    public playMidStackIdleAnimation(reelId: number, symbolId: number, tint: number, playdouble: boolean = false): TimelineLite {
        this._midStackIdle[0].position.set((120 * reelId) + 60, (199 * symbolId) + 50);
        this._midStackIdle[1].position.set((120 * reelId) + 60, 200 * (symbolId + 1.7));
        if (playdouble) {
            this._midStackIdle[2].position.set((120 * reelId) + 60, (199 * symbolId) + 50);
            this._midStackIdle[3].position.set((120 * reelId) + 60, 200 * (symbolId + 1.7));
        }

        this._midStackIdle.forEach((anim: TimelineSprite, index: number) => {
            if (index < 2 || playdouble) {
                anim.playLoop();
                anim.visible = true;
                anim.tint = tint;
            }

        });

        return new TimelineLite().fromTo({}, 2, {}, {
            onComplete: () => {
                this._midStackIdle.forEach(anim => {
                    TweenLite.fromTo(anim, 0.2, {alpha: 1}, {
                        alpha: 0, onComplete: () => {
                            anim.stopLoop();
                            anim.visible = false;
                            anim.alpha = 1;
                        }
                    });
                });
            }
        });

    }

    public clearMidStackIdleAnimation(): void {
        this._midStackIdle.forEach(value => {
            value.stopLoop();
            value.visible = false;
        });
    }

    /**
     * mask to add on idle animations so that it won't show up above reel area.
     */
    protected createGraphic(): void {
        this._graphicBg = new PIXI.Graphics();
        this._graphicBg.beginFill(0xFF3300);
        this._graphicBg.drawRect(-20, 90, 780, 594);
        this._graphicBg.endFill();
        this.addChild(this._graphicBg);
    }

    /**
     * function to create wild stack animation,
     * create an array for mid-4 reels
     */
    private createWildStackIdleAnimation(): void {
        for (let i = 0; i < 4; i++) {
            let wildIdleSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("wild_stack"));
            this._wildStackidleAnimation.push(wildIdleSpine);
            const x = ((i + 1) * 120) + 61, y = 387;
            // positioning of wild animations with code #210
            wildIdleSpine.position.set(x, y);
            wildIdleSpine.visible = false;
            wildIdleSpine.mask = this._graphicBg;
            this.addChild(wildIdleSpine);
        }
    }

    /**
     * function to play wil stack spine animation
     * @param reelId : reel id will be used to play different type of wild animation
     * @param animType : udes to play win or idle animation
     */
    public playWildAnimation(reelId: number, animType: string): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._wildStackidleAnimation[reelId - 1].updateTransform();
            this._wildStackidleAnimation[reelId - 1].visible = true;
        });
        tl.add(new SpineTween(this._wildStackidleAnimation[reelId - 1], 0, "w" + reelId.toString() + animType));
        tl.add(() => this._wildStackidleAnimation[reelId - 1].visible = false);
        return tl;
    }

    /**
     * function to hide all wild stack animation
     */
    public hideallWildStackAnimation() {
        this._wildStackidleAnimation.forEach((value: PIXI.spine.Spine) => value.visible = false);
    }
}